import { CustomerFavourites } from '../models';

export class FetchCustomerFavouritesList {
    static readonly type = '[CUSTOMERFAVOURITES] fetchCustomerFavourites';
    
    constructor(public payload?: string) {}
}


